import { render, staticRenderFns } from "./my_transaction_info.vue?vue&type=template&id=fd5e0630&scoped=true"
import script from "./my_transaction_info.vue?vue&type=script&lang=js"
export * from "./my_transaction_info.vue?vue&type=script&lang=js"
import style0 from "./my_transaction_info.vue?vue&type=style&index=0&id=fd5e0630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5e0630",
  null
  
)

export default component.exports